import { 
  RECEIVE_ERROR_RESPONSE,
  CLEAR_API_ERROR,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  error: null,
};

function apiReducer(state = INITIAL_STATE, action) {
  switch(action.type) {
    case RECEIVE_ERROR_RESPONSE: {
      return {
        ...state,
        error: action.error,
      };
    }
    case CLEAR_API_ERROR: {
      return {
        ...state,
        error: null,
      };
    }
    default:
      return state;
  }
}

export default apiReducer;